import React from 'react';
import styled from 'styled-components';
//import oh from 'output-helpers';

class Tag extends React.Component {

    constructor(props) {
        super(props);
        this.container = styled.div `
            color: #fff;
            display: inline-block;
            background-color: #2196f3;
            font-size: ${props => props.small ? '12px' : '14px'};
            white-space: nowrap;
            align-items: center;
            border-radius: 16px;
            vertical-align: middle;
            justify-content: center;
            margin-right: ${props => props.small ? '4px' : '8px'};
            margin-bottom: ${props => props.small ? '3px' : '6px'};
            &:last-child{
                margin-right: 0;
            }
            span{
                outline: none;
                padding: ${props => props.small ? '1px 6px' : '4px 12px'};
                display: inline-flex;
            }
        `;
    }
    renderButton() {

    }

    render() {
        return (
            <this.container small={this.props.small}>
                <span>
                    {this.props.label}
                </span> 
            </this.container>
        );
    }
}

export default Tag;



// WEBPACK FOOTER //
// ./src/components/base/Tag.jsx